import React from 'react';
import { observer } from 'mobx-react';

import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { getAccountsLite } from 'areas/administration/accounts/api';
import { useRemoteListForSelect } from 'framework/api';
import { translator } from 'core/localization';
import { AntSelectPropsGeneric, fieldNamesIdName } from 'controls/react/ant/ant-select/types';
import { Account } from 'areas/administration/accounts/types';

const i18n = translator({
	'Select an Account...': {
		no: 'Du må legge til en konto...',
	},
	'- Shared datasource -': {
		no: '- Delt datakilde -',
	},
});

export type AccountSelectorProps = AntSelectPropsGeneric<string> & {
	accountId?: string;
	hidePlaceholder?: boolean;
	withSharedDatasourceOption?: boolean;
};

export const AccountSelector = observer((props: AccountSelectorProps) => {
	const { accountId, hidePlaceholder, withSharedDatasourceOption, ...rest } = props;
	const remoteData = useRemoteListForSelect(getAccountsLite({ accountId }));

	const options = React.useMemo(() => {
		if (!withSharedDatasourceOption) {
			return remoteData.options;
		}

		const sharedOption: Account = { id: null, name: i18n('- Shared datasource -'), items: [] };
		return [sharedOption, ...remoteData.options];
	}, [remoteData.options, withSharedDatasourceOption]);

	return (
		<AntSelect
			placeholder={hidePlaceholder == true ? null : i18n('Select an Account...')}
			fieldNames={fieldNamesIdName}
			{...remoteData}
			options={options}
			{...rest}
		/>
	);
});

export type AccountsSelectorProps = AntSelectPropsGeneric<string[]> & {
	accountId?: string;
	hidePlaceholder?: boolean;
};

export const AccountsSelector = observer((props: AccountsSelectorProps) => {
	const { hidePlaceholder, mode, accountId, ...rest } = props;
	const remoteData = useRemoteListForSelect(getAccountsLite({ accountId }));
	const innerMode = mode === undefined ? 'multiple' : mode;

	return (
		<AntSelect
			mode={innerMode}
			placeholder={hidePlaceholder == true ? null : i18n('Select an Account...')}
			fieldNames={fieldNamesIdName}
			{...remoteData}
			{...rest}
		/>
	);
});
